import { render, staticRenderFns } from "./TagsField.vue?vue&type=template&id=14885742&scoped=true"
import script from "./TagsField.vue?vue&type=script&lang=js"
export * from "./TagsField.vue?vue&type=script&lang=js"
import style0 from "./TagsField.vue?vue&type=style&index=0&id=14885742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14885742",
  null
  
)

export default component.exports